export const validMessage = {
  wedding: {
    licenseNos: '회원명을 입력해주세요.',
    targetType: '결혼식 대상자를 선택해주세요.',
    date: '결혼식 일시를 선택해주세요.',
    address: '장소를 선택해주세요.',
    detailAddress: '상세주소를 입력해주세요.',
    contacts: '회원 연락처를 입력해주세요.',
    paymentAccount: '계좌를 입력해주세요.',
    actionType: '조치 종류를 선택해주세요.',
  },
  funeral: {
    licenseNos: '회원명을 입력해주세요.',
    targetType: '경조 대상자를 선택해주세요.',
    address: '장소를 선택해주세요.',
    detailAddress: '상세주소를 입력해주세요.',
    targetName: '고인명을 입력해주세요.',
    date: '별세 일시를 입력해주세요.',
    funeralDate: '발인 일시를 입력해주세요.',
    contacts: '회원 연락처를 입력해주세요.',
    remarks: '문구를 선택해 주세요.',
    paymentAccount: '계좌를 입력해주세요.',
    actionType: '조치 종류를 선택해주세요.',
  },
  opening: {
    licenseNos: '경조 대상자를 선택해주세요.',
    date: '개업 일시를 입력해주세요.',
    address: '장소를 선택해주세요.',
    detailAddress: '상세주소를 입력해주세요.',
    contacts: '회원 연락처를 입력해주세요.',
    paymentAccount: '계좌를 입력해주세요.',
    targetName: '개업장명을 입력해주세요.',
    actionType: '조치 종류를 선택해주세요.',
  },
};
